// Temporarily hide homepage entry points; keep the pipeline and playground available.
export const SHOW_AUTO_DIGITIZE_HOME = false;
